import React from 'react'
import styled from 'styled-components'
import Button from './Button'

const Container = styled.div`
  display: flex;
  margin: 40px 0 80px;
  justify-content: center;
`

export default () => (
  <Container>
    <Button to='/results/annual'>
      Average annual cost by age
    </Button>
    <Button to='/results/monthly'>
      Average monthly cost by age
    </Button>
  </Container>
)
